import { MapMarkerPlusIcon } from './MapMarkerPlusIcon';

/**
 * author: Simran
 * id 40CBD1A1-11E1-44A6-8627-6F7C658F5E0F
 * name map-marker-plus
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-plus.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationAddIcon = MapMarkerPlusIcon;
export default LocationAddIcon